import { createCtx } from './create-context.helper';
import { ProjectBranchViewModel } from '../libs/api-interface/models/project/project-branch-view.model';

export const [useProjectBranchContext, ProjectBranchContextProvider] = createCtx<ProjectBranchViewModel>();
